import * as core from '../../core'

/**
 * Template for agents that are automatically assigned to the zone creator
 * when a new zone is created. Follows the same pattern as {@link AppTemplate}.
 */
export interface AgentTemplate {
  readonly agentId: core.agent.Agent.Id
  readonly pageContext?: core.agent.ZoneConfig.PageContext
}
export namespace AgentTemplate {
  const TEMPLATES: readonly AgentTemplate[] = [
    { agentId: core.agent.Agent.Id.Naming },
    { agentId: core.agent.Agent.Id.DmsSchemaAssistant },
    { agentId: core.agent.Agent.Id.DmsQueryGenerator },
  ]

  /**
   * Returns all {@link AgentTemplate} entries to assign on zone creation.
   */
  export function list(): readonly AgentTemplate[] {
    return TEMPLATES
  }
}
